import * as actionTypes from './actionTypes';

export const fetchAllRoles = () => ({
  type: actionTypes.FETCH_ALL,
});
export const fetchAllRolesSuccess = (ids) => ({
  type: actionTypes.FETCH_ALL_SUCCESS,
  ids,
});


export const fetchAllSpaceRoles = (spaceId) => ({
  type: actionTypes.FETCH_ALL_SPACE_MEMBERS,
  spaceId,
});
export const fetchAllSpaceRolesSuccess = (ids, spaceId) => ({
  type: actionTypes.FETCH_ALL_SPACE_MEMBERS_SUCCESS,
  ids,
  spaceId,
});


export const createRole = (role) => ({
  type: actionTypes.CREATE,
  role,
});
export const createRoleSuccess = (role) => ({
  type: actionTypes.CREATE_SUCCESS,
  role,
});

export const deleteRole = (role) => ({
  type: actionTypes.DELETE,
  role,
});
export const deleteRoleSuccess = (id) => ({
  type: actionTypes.DELETE_SUCCESS,
  id,
});

export const updateRole = (role) => ({
  type: actionTypes.UPDATE,
  role,
});
export const updateRoleSuccess = (id) => ({
  type: actionTypes.UPDATE_SUCCESS,
  id,
});

export const setActiveRoleId = (id) => ({
  type: actionTypes.SET_ACTIVE_ROLE_ID,
  id,
});
